import { ListSubheader, MenuItem } from '@mui/material'
import { useUserContext } from '../../../../Contexts/UserConfig'

export function useCollectionSampleTypeOptions() {
  const { loginConfig } = useUserContext()

  // custom categorised list
  let sampleTypes: any[] = [<MenuItem key={null}>...loading</MenuItem>]
  if (loginConfig?.CodeSets?.SampleRunTypeID) {
    let items = loginConfig?.CodeSets.SampleRunTypeID.values
    sampleTypes = []

    //Removing hidden
    let remain = items.filter(
      (item) => !item.CodeDescription.includes('hidden'),
    )

    let subset: any[] = []

    const categories = {
      'DNA prep for mouse genotyping': [
        '100',
        '150',
        '200',
        '250',
        '300',
        '400',
      ],
      'Tissue/ blood for researcher': ['700', '750', '800', '850', '900'],
      'Health screening': [
        '500',
        '510',
        '520',
        '600',
        '610',
        '620',
        '630',
        '640',
        '650',
        '660',
        '670',
        '680',
        '690',
      ],
      'Genetic screening': ['710'],
    }

    for (const [key, value] of Object.entries(categories)) {
      items = remain
      sampleTypes.push(<ListSubheader key={key}>{key}</ListSubheader>)
      subset = items.filter((item) => value.includes(item.CodeValue.toString()))
      remain = items.filter(
        (item) => !value.includes(item.CodeValue.toString()),
      )
      subset.forEach(function (item) {
        sampleTypes.push(
          <MenuItem
            value={item.CodeValue}
            key={item.CodeValue}
          >
            {item.CodeDescription}
          </MenuItem>,
        )
      })
    }
    //Misc (remaining uncategorised)
    if (remain.length > 0) {
      sampleTypes.push(<ListSubheader>Misc</ListSubheader>)
      remain.forEach(function (item) {
        sampleTypes.push(
          <MenuItem
            value={item.CodeValue}
            key={item.CodeValue}
          >
            {item.CodeDescription}
          </MenuItem>,
        )
      })
    }
  }
  return sampleTypes
}
